import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchMatOutwardStkValue, fetchSingleMatOutward, updateMatOutwardEntry } from '../../Store/PHPSlice/MatOutward';


const MatOutwardEdit = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        dt: '',
        matOutId: parseInt(Id),
        matId: '',
        empNm: '',
        empId: '',
        materialNm: '',
        desp: '',
        size: '',
        pkt: '',
        qty: '',
        newQty: '',
        userId: userdata?.ID
    });

    const dispatch = useDispatch();

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const singelMatoutward = useSelector((state) => state.MatOutwardData.singleMatOutward || { data: [] });
    const stk_value = useSelector((state) => state.MatOutwardData.stkValue || { data: [] });
    useEffect(() => {
        dispatch(fetchSingleMatOutward(Id))
    }, [dispatch, Id]);
    useEffect(() => {
        if (singelMatoutward.data.length > 0) {
            const item = singelMatoutward.data[0];
            setFormData({
                ...formData,
                dt: item.dt,
                matId: item.matId,
                empId: item.empId,
                empNm: item.empNm,
                materialNm: item.materialNm,
                desp: item.description,
                size: item.size,
                pkt: item.pkt,
                qty: item.qty
            });
            const mId = item.matId;
            dispatch(fetchMatOutwardStkValue(mId));
        }
    }, [singelMatoutward]);

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;


        const val = stk_value.data.length > 0 ? stk_value.data[0].qty : 0; // Default to 0 if singelMatInward.data is not yet populated
        let newValue = value;
        if (name === 'newQty' && parseInt(value, 10) > val) {
            alert(`Value cannot be greater than ${val}`);
            newValue = ''; // Reset the field to empty string
        }
        setFormData({
            ...formData,
            newQty: newValue
        });

    };
    const handleSubmit = (e) => {
        e.preventDefault();

        dispatch(updateMatOutwardEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Material Outward Updated");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>

            <div style={{ margin: '1%' }}>
                <h2>Material Inward Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={2}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Employee', name: 'empNm' },
                                    { label: 'Material', name: 'materialNm' },
                                    { label: 'Description', name: 'desp' },
                                    { label: 'Size', name: 'size' },
                                    { label: 'Packets', name: 'pkt' },
                                    { label: 'Qty', name: 'qty' },
                                    { label: 'New Qty', name: 'newQty' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.name !== 'newQty' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default MatOutwardEdit;
